import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { deleteRequest, getRequest, patchRequest, postRequest, ResponseDataType } from 'api';
import { Card, Row, Col, Table, TableProps, Button, Modal, Input, Space, List, InputNumber, Select, Popconfirm, Checkbox, Radio, Tooltip } from 'antd';
import { DatePicker } from 'Components';
import { toast } from 'react-toastify';
import { ROLE, checkRole } from 'constant/role';
import { StudentFullInfo } from 'Pages/Revenue';
import { Form } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

import dayjs from 'dayjs';
interface ClassYearData {
    classYearId: number;
    className: string;
    classLevel: string;
    schoolName: string;
    schoolYear: string;
}

interface StudentData {
    studentId: number;
    name: string;
    dob: string;
    gender: number;
    studentCode: string;
    cmnd: string;
    registeredIncomes?: string[];
    studentClassYearId: number;
    totalIncomeCount?: number;
    invoicedIncomeCount?: number;
}
interface HomeroomTeacher {
    teacherId: number;
    fullName: string;
    dob: string;
    phoneNumber: string;
}
interface SubjectTeacher {
    teacherId: number;
    customerId: number;
    gender: number;
    fullName: string;
    dob: string;
    phoneNumber: string;
    email: string;
    address: string;
    currentStatus: number;
    contractType: number;
    schoolId: number;
}
interface IncomeSourceData {
    id: number;
    description: string;
    unitPrice: number;
    expectedUnits: number;
    actualUnits: number;
    createdDate: number[];
    updatedDate: number[];
    incomeSchoolId: number;
}
export const ListStudentIncome = () => {
    const navigate = useNavigate();
    const [incomeModalVisible, setIncomeModalVisible] = useState(false);
    const [selectedStudentId, setSelectedStudentId] = useState<number | null>(null);

    const [incomeForm, setIncomeForm] = useState({
        unitType: 1,
        description: '',
        unitPrice: '',
        expectedUnits: ''
    });
    const [form] = Form.useForm();
    const [selectedIncome, setSelectedIncome] = useState<IncomeSourceData | null>(null);
    const [selectedType, setSelectedType] = useState<number | null>(null);
    const [incomeSources, setIncomeSources] = useState<{ id: number; name: string }[]>([]);
    const [editForm] = Form.useForm();
    const [showEditClassModal, setShowEditClassModal] = useState(false);
    const [subjectTeachers, setSubjectTeachers] = useState<SubjectTeacher[]>([]);
    const [showAddModal, setShowAddModal] = useState(false);
    const [subjectTeacherSearchResults, setSubjectTeacherSearchResults] = useState<SubjectTeacher[]>([]);
    const [loadingSubjectSearch, setLoadingSubjectSearch] = useState(false);
    const isAdmin = checkRole(ROLE.ADMIN);
    const isAccountant = checkRole(ROLE.ACCOUNTANT);
    const [homeroomTeacher, setHomeroomTeacher] = useState<HomeroomTeacher[] | null>(null);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [showAddTeacherModal, setShowAddTeacherModal] = useState(false);
    const [newTeacherEmail, setNewTeacherEmail] = useState('');
    const [teacherSearchResults, setTeacherSearchResults] = useState<any[]>([]);
    const [loadingTeacherSearch, setLoadingTeacherSearch] = useState(false);
    const [selectedIncomeType, setSelectedIncomeType] = useState<number | null>(null);
    const schoolId = Number(localStorage.getItem("schoolId"));
    const [periodType, setPeriodType] = useState<'month' | 'year'>('month');

    const getInitialSchoolYear = () => {
        if (classInfo?.schoolYear) {
            const match = classInfo.schoolYear.match(/\d{4}/);
            if (match) {
                return dayjs().year(parseInt(match[0], 10));
            }
        }
        return dayjs();
    };

    const handleOpenIncomeModal = () => {
        setPeriodType('month');
        form.resetFields();
        form.setFieldsValue({
            periodType: 'month',
            monthYear: dayjs(),
            schoolYear: getInitialSchoolYear(),
        });
        setIncomeModalVisible(true);
    };

    const renderPeriodSelection = () => (
        <>
            <Form.Item label="Kỳ thu" style={{ marginBottom: 12 }}>
                <Radio.Group
                    value={periodType}
                    onChange={(e) => {
                        const newType = e.target.value as 'month' | 'year';
                        setPeriodType(newType);
                        form.setFieldsValue({ periodType: newType });
                        const allValues = { ...form.getFieldsValue(), periodType: newType };
                        const name = allValues.incomeName || '';
                        let timeStr = '';
                        if (newType === 'year') {
                            const sYear = allValues.schoolYear || getInitialSchoolYear();
                            form.setFieldsValue({ schoolYear: sYear });
                            const y = sYear.year();
                            timeStr = ` Năm học ${y}-${y + 1}`;
                        } else {
                            const mYear = allValues.monthYear || dayjs();
                            form.setFieldsValue({ monthYear: mYear });
                            timeStr = ` ${mYear.format('MM/YYYY')}`;
                        }
                        if (name || timeStr) {
                            form.setFieldsValue({ description: `${name}${timeStr}`.trim() });
                        }
                    }}
                >
                    <Radio.Button value="month">Theo Tháng/Năm</Radio.Button>
                    <Radio.Button value="year">Theo Năm học</Radio.Button>
                </Radio.Group>
            </Form.Item>

            {periodType === 'month' ? (
                <Form.Item name="monthYear" label="Tháng/Năm" rules={[{ required: true, message: 'Vui lòng chọn tháng/năm' }]}>
                    <DatePicker picker="month" style={{ width: '100%' }} placeholder="Chọn tháng/năm" format="MM/YYYY" />
                </Form.Item>
            ) : (
                <Form.Item name="schoolYear" label="Năm học" rules={[{ required: true, message: 'Vui lòng chọn năm học' }]}>
                    <DatePicker
                        picker="year"
                        style={{ width: '100%' }}
                        placeholder="Chọn năm học"
                        format={(val) => `${val.year()}-${val.year() + 1}`}
                    />
                </Form.Item>
            )}
        </>
    );
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
    const [selectedStudentForDetail, setSelectedStudentForDetail] = useState<StudentData | undefined>();

    const { classYearId } = useParams<{ classYearId: string }>();
    const [classInfo, setClassInfo] = useState<ClassYearData | null>(null);
    const [students, setStudents] = useState<StudentData[]>([]);
    const [studentKeyword, setStudentKeyword] = useState('');
    const [selectedIncomeFilter, setSelectedIncomeFilter] = useState<string[]>([]);
    const [selectedInvoiceStatusFilter, setSelectedInvoiceStatusFilter] = useState<string | null>(null);
    const [searchResults, setSearchResults] = useState<StudentData[]>([]);
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    const normalizeSearchText = (value?: string) => {
        return (value || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/đ/g, 'd')
            .replace(/Đ/g, 'D')
            .toLowerCase()
            .replace(/\s+/g, ' ')
            .trim();
    };

    const hasVietnameseAccent = (value?: string) => {
        if (!value) return false;
        return value.normalize('NFD') !== value;
    };

    const rawKeyword = (studentKeyword || '').toLowerCase().replace(/\s+/g, ' ').trim();
    const normalizedKeyword = normalizeSearchText(studentKeyword);
    const isAccentedQuery = hasVietnameseAccent(studentKeyword);

    const uniqueIncomes = Array.from(
        new Set(
            students.flatMap((student) => student.registeredIncomes || [])
        )
    ).filter(Boolean);

    const filteredStudents = students.filter((student) => {
        let matchKeyword = true;
        if (normalizedKeyword) {
            const rawName = (student.name || '').toLowerCase().replace(/\s+/g, ' ').trim();
            const rawCmnd = (student.cmnd || '').toLowerCase().replace(/\s+/g, ' ').trim();
            const normalizedName = normalizeSearchText(student.name);
            const normalizedCmnd = normalizeSearchText(student.cmnd);

            const isRawMatch = rawName.includes(rawKeyword) || rawCmnd.includes(rawKeyword);
            const isNormalizedMatch = normalizedName.includes(normalizedKeyword) || normalizedCmnd.includes(normalizedKeyword);

            matchKeyword = isAccentedQuery ? isRawMatch : (isRawMatch || isNormalizedMatch);
        }

        let matchIncome = true;
        if (selectedIncomeFilter && selectedIncomeFilter.length > 0) {
            const hasUnregistered = selectedIncomeFilter.includes('UNREGISTERED');
            const otherFilters = selectedIncomeFilter.filter(f => f !== 'UNREGISTERED');

            const isUnregisteredMatch = hasUnregistered && (!student.registeredIncomes || student.registeredIncomes.length === 0);
            const isRegisteredMatch = otherFilters.length > 0 && (student.registeredIncomes?.some(income => otherFilters.includes(income)) ?? false);

            matchIncome = isUnregisteredMatch || isRegisteredMatch;
        }

        let matchInvoiceStatus = true;
        if (selectedInvoiceStatusFilter) {
            const total = student.totalIncomeCount || 0;
            const invoiced = student.invoicedIncomeCount || 0;

            if (selectedInvoiceStatusFilter === 'NO_INCOME') {
                matchInvoiceStatus = total === 0;
            } else if (selectedInvoiceStatusFilter === 'NOT_INVOICED') {
                matchInvoiceStatus = total > 0 && invoiced === 0;
            } else if (selectedInvoiceStatusFilter === 'PARTIAL') {
                matchInvoiceStatus = total > 0 && invoiced > 0 && invoiced < total;
            } else if (selectedInvoiceStatusFilter === 'FULLY_INVOICED') {
                matchInvoiceStatus = total > 0 && invoiced === total;
            }
        }

        return matchKeyword && matchIncome && matchInvoiceStatus;
    });

    useEffect(() => {
        if (classYearId) {
            fetchClassInfo(classYearId);
            fetchStudentsInClass(classYearId);
            fetchHomeroomTeacher(classYearId);
            fetchSubjectTeachers(classYearId);
        }
    }, [classYearId]);

    const fetchClassInfo = async (id: string) => {
        const response: ResponseDataType<ClassYearData> = await getRequest(`/cms/class/get-class-year-info?classYearId=${id}`);
        if (response?.code === 200 && response.info) {
            setClassInfo(response.info);
        } else {
            toast.error('Không thể tải thông tin lớp học');
        }
    };
    const fetchSubjectTeachers = async (id: string) => {
        try {
            const res: ResponseDataType<any> = await getRequest(`/cms/teacher/get-subject-teacher-by-class-year?classYearId=${id}`);
            if (res?.code === 200 && Array.isArray(res.info) && res.info.length > 0) {
                setSubjectTeachers(res.info);
            } else {
                setSubjectTeachers([]);
            }
        } catch (error) {
            toast.error("Lỗi khi tải danh sách giáo viên bộ môn");
        }
    };
    const fetchHomeroomTeacher = async (id: string) => {
        const response: ResponseDataType<any> = await getRequest(`/cms/teacher/get-homeroom-teacher-by-class-year?classYearId=${id}`);
        if (response?.code === 200 && Array.isArray(response.info) && response.info.length > 0) {
            setHomeroomTeacher(response.info);
        } else {
            setHomeroomTeacher(null);
        }
    };
    const handleAddSubjectTeacher = async (teacherId: number) => {
        try {
            const res = await postRequest(`/cms/class/${classYearId}/add-teacher-to-class-year?role=2`, {
                teacherId,
            });
            if (res?.code === 200) {
                toast.success("Đã thêm giáo viên bộ môn");
                fetchSubjectTeachers(classYearId!);
                setShowAddModal(false);
                // setSubjectTeacherSearchResults([]);
            } else {
                toast.error(res?.msg || "Thêm thất bại");
            }
        } catch (err) {
            toast.error("Lỗi khi gọi API thêm giáo viên");
        }
    };
    const handleAddTeacher = async (teacherId: number) => {
        const response = await postRequest(
            `/cms/class/${classYearId}/add-teacher-to-class-year?role=1`,
            { teacherId }
        );

        if (response?.code === 200) {
            toast.success('Đã thêm giáo viên chủ nhiệm');
            setShowAddTeacherModal(false);
            fetchHomeroomTeacher(classYearId!);
        } else {
            toast.error(response?.msg || 'Thêm giáo viên thất bại');
        }
    };
    const handleDeleteTeacher = async (teacherId: number) => {
        try {
            const res = await deleteRequest(`/cms/class/${classYearId}/delete-teacher-to-class-year?role=2`, {
                teacherId,
            });
            if (res?.code === 200) {
                toast.success("Đã xóa giáo viên bộ môn");
                fetchSubjectTeachers(classYearId!);
            } else {
                toast.error(res?.msg || "Xóa thất bại");
            }
        } catch (err) {
            toast.error("Lỗi khi gọi API xóa giáo viên");
        }
    };



    const fetchStudentsInClass = async (id: string) => {
        const response: ResponseDataType<{ list: StudentData[] }> = await getRequest(`/cms/student/get-students-by-class-year?classYearId=${id}`);
        if (response?.code === 200 && response.info && Array.isArray(response.info.list)) {
            setStudents(response.info.list);
        } else {
            setStudents([]);
            toast.error('Không thể tải danh sách học sinh');
        }
    };
    const handleCreateIncome = async () => {
        try {
            const values = await form.validateFields();
            if (!classYearId) return;

            let month = 0;
            let year = dayjs().year();

            if (periodType === 'year' || values.periodType === 'year') {
                month = 0;
                year = values.schoolYear ? values.schoolYear.year() : getInitialSchoolYear().year();
            } else {
                const selectedMonthYear = values.monthYear;
                month = selectedMonthYear ? selectedMonthYear.month() + 1 : 0;
                year = selectedMonthYear ? selectedMonthYear.year() : dayjs().year();
            }

            const payload = {
                ...values,
                month,
                year,
                actualUnits: values.expectedUnits,
                status: 0,
            };

            if (selectedRowKeys.length === 0) {
                toast.error("Vui lòng chọn ít nhất một học sinh");
                return;
            }

            const selectedStudentClassYearIds = students
                .filter(s => selectedRowKeys.includes(s.studentId))
                .map(s => s.studentClassYearId);

            const checkDuplicatePromises = selectedStudentClassYearIds.map(async (id) => {
                try {
                    const checkRes: any = await getRequest(
                        `/cms/accountant/income-student-register/student-class-year-and-status?studentClassYearId=${id}`
                    );
                    if (checkRes.code === 200 && Array.isArray(checkRes.info?.list)) {
                        return checkRes.info.list.some((inc: any) =>
                            inc.incomeSchoolId === values.incomeSchoolId &&
                            inc.month === month &&
                            inc.year === year
                        );
                    }
                } catch (e) {
                    // Bỏ qua lỗi nếu fetch thất bại cho 1 học sinh
                }
                return false;
            });

            const duplicateResults = await Promise.all(checkDuplicatePromises);
            const isDuplicate = duplicateResults.some(res => res);

            const submitPayload = async () => {
                const res = await postRequest(
                    `/cms/accountant/income-student-register/list-student-class-years?studentClassYearIds=${selectedStudentClassYearIds.join(',')}`,
                    payload
                );

                if (res.code === 200) {
                    toast.success("Tạo nguồn thu thành công");
                    setIncomeModalVisible(false);
                    form.resetFields();
                    setSelectedRowKeys([]);

                    // Gọi lại API để reload danh sách sau khi thêm
                    fetchStudentsInClass?.(classYearId);
                } else {
                    toast.error(res.msg || "Tạo nguồn thu thất bại");
                }
            };

            if (isDuplicate) {
                Modal.confirm({
                    title: 'Xác nhận tạo thêm',
                    content: 'Có một hoặc nhiều học sinh đã tồn tại khoản thu này trong kỳ thu tương ứng. Bạn có chắc chắn muốn tạo thêm bản ghi thứ hai cho các học sinh này không?',
                    okText: 'Đồng ý',
                    cancelText: 'Hủy',
                    onOk: submitPayload,
                });
                return;
            }

            await submitPayload();
        } catch (error) {
            toast.error("Vui lòng kiểm tra lại thông tin");
        }
    };


    const handleSearchTeacherByEmail = async (email: string) => {
        const schoolId = localStorage.getItem('schoolId');
        if (!schoolId) {
            toast.error('Không tìm thấy schoolId');
            return;
        }

        setLoadingTeacherSearch(true);
        const response: ResponseDataType<{ teacherId: number; fullName: string }[]> =
            await getRequest(`/cms/teacher/get-teacher-by-email-and-schoolId?email=${email}&schoolId=${schoolId}`);

        if (response?.code === 200 && Array.isArray(response.info)) {
            setTeacherSearchResults(response.info);
        } else {
            toast.error(response?.msg || 'Không tìm thấy giáo viên');
            setTeacherSearchResults([]);
        }
        setLoadingTeacherSearch(false);
    };


    const handleSearchSubjectTeacherByEmail = async (email: string) => {
        const schoolId = localStorage.getItem('schoolId');
        if (!schoolId) {
            toast.error('Không tìm thấy schoolId');
            return;
        }

        setLoadingSubjectSearch(true);

        const response: ResponseDataType<SubjectTeacher[]> = await getRequest(
            `/cms/teacher/get-teacher-by-email-and-schoolId?email=${email}&schoolId=${schoolId}`
        );

        if (response?.code === 200 && Array.isArray(response.info)) {
            setSubjectTeacherSearchResults(response.info);
        } else {
            toast.error(response?.msg || 'Không tìm thấy giáo viên');
            setSubjectTeacherSearchResults([]);
        }

        setLoadingSubjectSearch(false);
    };





    const handleUpdateHomeroomTeacher = async (teacherId: number) => {
        try {
            if (Array.isArray(homeroomTeacher) && homeroomTeacher.length > 0) {
                for (const teacher of homeroomTeacher) {
                    const deleteResponse = await deleteRequest(
                        `/cms/class/${classYearId}/delete-teacher-to-class-year?role=1`,
                        { teacherId: teacher.teacherId }
                    );

                    if (deleteResponse?.code !== 200) {
                        toast.error(deleteResponse?.msg || 'Không thể xoá giáo viên cũ');
                        return;
                    }
                }
            }

            const addResponse = await postRequest(
                `/cms/class/${classYearId}/add-teacher-to-class-year?role=1`,
                { teacherId }
            );

            if (addResponse?.code === 200) {
                toast.success('Cập nhật giáo viên chủ nhiệm thành công');
                setShowUpdateModal(false);
                fetchHomeroomTeacher(classYearId!);
            } else {
                toast.error(addResponse?.msg || 'Không thể thêm giáo viên mới');
            }
        } catch (err) {
            toast.error('Đã xảy ra lỗi khi cập nhật giáo viên chủ nhiệm');
        }
    };


    const handleDeleteStudent = async (studentId: number) => {
        const response: ResponseDataType<{}> = await deleteRequest(`/cms/class/${classYearId}/delete-studentClassYear`, { studentId });

        if (response?.code === 200) {
            toast.success('Xoá học sinh thành công');
            fetchStudentsInClass(classYearId!);
        } else {
            toast.error(response?.msg || 'Xoá học sinh thất bại');
        }
    };

    const handleSearchByCMND = async (cmnd: string) => {
        if (!cmnd || cmnd.length < 3) {
            toast.warning('Vui lòng nhập CCCD hợp lệ');
            return;
        }

        setLoadingSearch(true);
        const response: ResponseDataType<StudentData> = await getRequest(`/cms/student/get-student-by-cmnd?cmnd=${cmnd}`);
        if (response?.code === 200 && response.info) {
            setSearchResults([response.info]);
        } else {
            setSearchResults([]);
            toast.error(response?.msg || 'Không tìm thấy học sinh');
        }
        setLoadingSearch(false);
    };
    const handleIncomeTypeChange = (value: number) => {
        setSelectedType(value);
        setSelectedIncomeType(value);
        setIncomeSources([]);
        form.setFieldsValue({
            type: value,
            incomeName: undefined,
            incomeSchoolId: undefined,
        });
        handleTypeChange(value); // ⬅️ RẤT QUAN TRỌNG
    };
    const handleTypeChange = async (type: number) => {
        setIncomeSources([]);
        try {
            const res = await getRequest(`/cms/accountant/income-school/get-income-school-by-school-and-type?schoolId=${schoolId}&type=${type}`);
            if (res.code === 200 && Array.isArray(res.info)) {
                setIncomeSources(res.info.map((item: any) => ({ id: item.id, name: item.name })));
            } else {
                setIncomeSources([]);
                toast.error("Không thể tải danh sách tên nguồn thu");
            }
        } catch (e) {
            setIncomeSources([]);
            toast.error("Lỗi khi tải tên nguồn thu");
        }
    };
    const handleAddStudent = async (studentId: number) => {
        const response = await postRequest(`/cms/class/${classYearId}/add-student-to-class-year`, { studentId });

        if (response?.code === 200) {
            toast.success('Đã thêm học sinh');
            fetchStudentsInClass(classYearId!);
            setShowModal(false);
        } else {
            toast.error(response?.msg || 'Thêm học sinh thất bại');
        }
    };
    const handleNameChange = (name: string) => {
        const source = incomeSources.find((s) => s.name === name);
        if (source) {
            form.setFieldsValue({ incomeSchoolId: source.id });
        }
    };
    const columns: TableProps<StudentData>['columns'] = [
        {
            title: 'STT',
            key: 'stt',
            align: 'center',
            width: 50,
            render: (text, record, index) => index + 1,
        },
        { title: 'CCCD', dataIndex: 'cmnd', key: 'cmnd', width: 110, align: 'center' },
        { title: 'Họ tên', dataIndex: 'name', key: 'name', width: 150, align: 'left' },
        { title: 'Lớp', key: 'className', width: 65, align: 'center', render: () => classInfo?.className || '' },
        { title: 'Ngày sinh', dataIndex: 'dob', key: 'dob', width: 95, align: 'center' },

        {
            title: 'Giới tính',
            dataIndex: 'gender',
            key: 'gender',
            width: 70,
            align: 'center',
            render: (gender) => (gender === 1 ? 'Nam' : 'Nữ'),
        },
        {
            title: 'Danh sách khoản thu đã đăng ký',
            key: 'registeredIncomes',
            align: 'left',
            ellipsis: {
                showTitle: false,
            },
            render: (_, record) => {
                if (record.registeredIncomes && record.registeredIncomes.length > 0) {
                    const fullText = record.registeredIncomes.join(', ');
                    return (
                        <Tooltip title={fullText} placement="topLeft">
                            <span style={{ cursor: 'pointer' }}>{fullText}</span>
                        </Tooltip>
                    );
                }
                return (
                    <div style={{ display: 'inline-block', padding: '2px 8px', borderRadius: '4px', backgroundColor: '#fff1f0', color: '#f5222d', border: '1px solid #ffa39e', fontSize: '12px' }}>
                        Chưa đăng ký
                    </div>
                );
            },
        },
        {
            title: 'Trạng thái Invoice',
            key: 'invoiceStatus',
            width: 130,
            align: 'center',
            render: (_, record) => {
                const total = record.totalIncomeCount || 0;
                const invoiced = record.invoicedIncomeCount || 0;

                if (total === 0) {
                    return <span style={{ color: '#8c8c8c' }}>-</span>;
                }
                if (invoiced === 0) {
                    return <span style={{ color: '#fa8c16', fontWeight: 500 }}>Chưa tạo</span>;
                }
                if (invoiced < total) {
                    return <span style={{ color: '#1890ff', fontWeight: 500 }}>Đã tạo ({invoiced}/{total})</span>;
                }
                return <span style={{ color: '#52c41a', fontWeight: 500 }}>Đã tạo ({invoiced}/{total})</span>;
            },
        },
        {
            title: 'Hành động',
            key: 'action',
            width: 80,
            align: 'center',
            render: (_, record) => {
                if (isAdmin) {
                    return (
                        <Button danger onClick={() => {
                            Modal.confirm({
                                title: 'Bạn có chắc chắn muốn xoá học sinh này?',
                                okText: 'Xoá',
                                okType: 'danger',
                                cancelText: 'Hủy',
                                onOk: () => handleDeleteStudent(record.studentId),
                            });
                        }}>Xoá</Button>
                    );
                } else if (isAccountant) {
                    return (
                        <Button type="link" onClick={() => {
                            setSelectedStudentForDetail(record);
                            setIsDetailModalOpen(true);
                        }}>
                            Chi tiết
                        </Button>

                    );
                } else {
                    return null;
                }
            }
        },
    ];
    return (
        <div>
            <Card
                bordered={false}
                style={{
                    borderRadius: '8px',
                    border: '1px solid #f0f2f5',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                    marginBottom: 16,
                }}
                bodyStyle={{ padding: '12px 16px' }}
                styles={{ body: { padding: '12px 16px' } }}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: 12,
                    }}
                >
                    <h3 style={{ margin: 0, fontSize: 16 }}>Thông tin chung</h3>
                    {isAdmin && (
                        <Button
                            type="primary"
                            size="small"
                            onClick={() => {
                                if (classInfo) {
                                    editForm.setFieldsValue({
                                        className: classInfo.className,
                                        classLevel: classInfo.classLevel,
                                        schoolYear: classInfo.schoolYear,
                                    });
                                    setShowEditClassModal(true);
                                }
                            }}
                        >
                            Cập nhật thông tin lớp
                        </Button>
                    )}
                </div>

                {classInfo ? (
                    <Row gutter={[16, 12]}>
                        <Col xs={24} sm={12} md={6}>
                            <strong>Trường học:</strong> {classInfo.schoolName || '-'}
                        </Col>
                        <Col xs={12} sm={6} md={6}>
                            <strong>Năm học:</strong> {classInfo.schoolYear || '-'}
                        </Col>
                        <Col xs={12} sm={6} md={6}>
                            <strong>Khối lớp:</strong> {classInfo.classLevel ? `Khối ${classInfo.classLevel}` : '-'}
                        </Col>
                        <Col xs={12} sm={6} md={6}>
                            <strong>Tên lớp:</strong> {classInfo.className || '-'}
                        </Col>
                    </Row>
                ) : (
                    <div>Đang tải thông tin lớp...</div>
                )}
            </Card>

            <Modal
                title="Cập nhật thông tin lớp"
                open={showEditClassModal}
                onCancel={() => setShowEditClassModal(false)}
                onOk={async () => {
                    try {
                        const values = await editForm.validateFields();

                        if (!classInfo) {
                            toast.error("Không có thông tin lớp để cập nhật");
                            return;
                        }

                        const payload = {
                            ...classInfo, // giữ nguyên tất cả thông tin cũ
                            classLevel: values.classLevel,
                            className: values.className,
                            schoolYear: values.schoolYear,
                            classYearID: Number(classYearId), // có thể đã có trong classInfo nhưng để chắc ăn
                        };

                        const result = await patchRequest(
                            "/cms/class/update-class-year",
                            payload
                        );

                        if (result?.code === 200) {
                            toast.success("Cập nhật lớp thành công");
                            setShowEditClassModal(false);
                            fetchClassInfo(classYearId!);
                        } else {
                            toast.error(result?.msg || "Cập nhật thất bại");
                        }
                    } catch (err) {
                        toast.error("Vui lòng nhập đầy đủ thông tin hợp lệ");
                    }
                }}
                okText="Lưu"
                cancelText="Hủy"
            >
                <Form form={editForm} layout="vertical">
                    <Form.Item label="Tên lớp" name="className" rules={[{ message: "Nhập tên lớp" }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label="Khối" name="classLevel">
                        <Input placeholder="Nhập khối" />
                    </Form.Item>
                    <Form.Item label="Năm học" name="schoolYear" rules={[{ message: "Nhập năm học" }]}>
                        <Input placeholder="Ví dụ: Năm học 2025-2026" />
                    </Form.Item>
                </Form>
            </Modal>


            {/* <div style={{ backgroundColor: '#f5f8fa', padding: 16, borderRadius: 8, marginBottom: 24 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3>Thông tin giáo viên chủ nhiệm</h3>

                    {isAdmin && (
                        <div style={{ marginBottom: 8 }}>
                            <Button type="primary" icon={<PlusOutlined />}
                                onClick={() => setShowAddTeacherModal(true)}>
                                Thêm giáo viên chủ nhiệm
                            </Button>

                        </div>
                    )}
                </div>

                <Table

                    columns={[
                        { title: 'Họ tên', dataIndex: 'fullName', key: 'fullName', align: 'center' as const },
                        { title: 'Ngày sinh', dataIndex: 'dob', key: 'dob', align: 'center' as const },
                        { title: 'Số điện thoại', dataIndex: 'phoneNumber', key: 'phoneNumber', align: 'center' as const },
                        ...(isAdmin
                            ? [
                                {
                                    title: 'Hành động',
                                    key: 'action',
                                    align: 'center' as const,
                                    render: (_: any, record: any) => (
                                        <>
                                            <Button
                                                type="link"
                                                onClick={() => {

                                                    setShowUpdateModal(true);
                                                }}
                                            >
                                                Cập nhật
                                            </Button>

                                            <Button
                                                type="link"
                                                danger
                                                onClick={() => {
                                                    Modal.confirm({
                                                        title: "Bạn có chắc chắn muốn xóa giáo viên chủ nhiệm này không?",
                                                        content: "Hành động này không thể hoàn tác.",
                                                        okText: "Xóa",
                                                        cancelText: "Hủy",
                                                        okType: "danger",

                                                        async onOk() {
                                                            if (!classYearId || !record.teacherId) {
                                                                toast.error("Thiếu classYearId hoặc teacherId");
                                                                return;
                                                            }

                                                            try {
                                                                const res = await deleteRequest(
                                                                    `/cms/class/${classYearId}/delete-teacher-to-class-year?role=1`,
                                                                    { teacherId: record.teacherId }
                                                                );

                                                                if (res?.code === 200) {
                                                                    toast.success("Đã xóa giáo viên chủ nhiệm");
                                                                    fetchClassInfo(classYearId);
                                                                    fetchHomeroomTeacher(classYearId);
                                                                } else {
                                                                    toast.error(res?.msg || "Xóa thất bại");
                                                                }
                                                            } catch (err) {
                                                                toast.error("Lỗi khi gọi API xóa GVCN");
                                                            }
                                                        }
                                                    });
                                                }}
                                            >
                                                Xóa
                                            </Button>

                                        </>
                                    ),
                                },
                            ]
                            : []),

                    ]}


                    dataSource={Array.isArray(homeroomTeacher) ? homeroomTeacher : []}
                    rowKey="teacherId"
                    pagination={false}
                    locale={{ emptyText: 'Chưa có giáo viên chủ nhiệm' }}
                />
            </div> */}


            <Modal
                title="Thêm giáo viên chủ nhiệm"
                open={showAddTeacherModal}
                onCancel={() => {
                    setShowAddTeacherModal(false);
                    setTeacherSearchResults([]);
                    setLoadingTeacherSearch(false);
                }}
                footer={null}
            >
                <Input.Search
                    placeholder="Nhập email giáo viên"
                    enterButton="Tìm kiếm"
                    loading={loadingTeacherSearch}
                    onSearch={handleSearchTeacherByEmail}
                />
                <List
                    style={{ marginTop: 16 }}
                    dataSource={teacherSearchResults}
                    bordered
                    renderItem={(item) => (
                        <List.Item
                            actions={[
                                <Button type="link" onClick={() => handleAddTeacher(item.teacherId)}>Thêm</Button>,
                            ]}
                        >
                            <Space direction="vertical">
                                <b>{item.fullName}</b>
                                <span>({item.email})</span>
                            </Space>
                        </List.Item>

                    )}
                />
            </Modal>
            {/* <div style={{ backgroundColor: '#f5f8fa', padding: 16, borderRadius: 8, marginBottom: 24 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h3 style={{ margin: 0 }}>Danh sách giáo viên bộ môn</h3>
                    {isAdmin && (
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => setShowAddModal(true)}
                        >
                            Thêm giáo viên bộ môn
                        </Button>
                    )}
                </div>
                <Table
                    columns={[
                        { title: 'Họ tên', dataIndex: 'fullName', key: 'fullName', align: 'center' as const },
                        { title: 'Ngày sinh', dataIndex: 'dob', key: 'dob', align: 'center' as const },
                        { title: 'Số điện thoại', dataIndex: 'phoneNumber', key: 'phoneNumber', align: 'center' as const },

                        ...(isAdmin ? [{
                            title: 'Hành động',
                            key: 'action',

                            render: (_: any, record: SubjectTeacher) => (
                                <Button
                                    type="link"
                                    danger
                                    onClick={() => {
                                        Modal.confirm({
                                            title: 'Bạn có chắc chắn muốn xóa giáo viên này?',
                                            content: 'Hành động này không thể hoàn tác.',
                                            okText: 'Xóa',
                                            cancelText: 'Hủy',
                                            okType: 'danger',
                                            centered: true,
                                            onOk: async () => {
                                                await handleDeleteTeacher(record.teacherId);
                                            }
                                        });
                                    }}
                                >
                                    Xóa
                                </Button>
                            )
                        }] : [])

                    ]}
                    dataSource={subjectTeachers}
                    rowKey="teacherId"
                    pagination={false}
                    locale={{ emptyText: 'Chưa có giáo viên bộ môn' }}
                />


            </div> */}


            <Modal
                title="Thêm giáo viên bộ môn"
                open={showAddModal}
                onCancel={() => {
                    setShowAddModal(false);
                    setSubjectTeacherSearchResults([]);
                }}
                footer={null}
            >
                <Input.Search
                    placeholder="Nhập email giáo viên"
                    enterButton="Tìm kiếm"
                    loading={loadingSubjectSearch}
                    onSearch={handleSearchSubjectTeacherByEmail}
                />
                <List
                    dataSource={subjectTeacherSearchResults}
                    renderItem={(item: any, index) => (
                        <List.Item
                            key={index}
                            actions={[
                                <Button type="link" onClick={() => handleAddSubjectTeacher(item.teacherId)}>Thêm</Button>,
                            ]}
                        >
                            <Space direction="vertical">
                                <b>{item.fullName}</b>
                                <span>({item.email || 'Chưa có email'})</span>
                            </Space>
                        </List.Item>
                    )}
                />
            </Modal>
            <Modal
                title="Cập nhật giáo viên chủ nhiệm"
                open={showUpdateModal}
                onCancel={() => {
                    setShowUpdateModal(false);
                    setTeacherSearchResults([]);
                    setLoadingTeacherSearch(false);
                }}
                footer={null}
            >
                <Input.Search
                    placeholder="Nhập email giáo viên"
                    enterButton="Tìm kiếm"
                    loading={loadingTeacherSearch}
                    onSearch={handleSearchTeacherByEmail}
                />
                <List
                    style={{ marginTop: 16 }}
                    dataSource={teacherSearchResults}
                    bordered
                    renderItem={(item) => (
                        <List.Item actions={[<Button type="link" onClick={() => handleUpdateHomeroomTeacher(item.teacherId)}>Cập nhật</Button>]}>
                            <Space direction="vertical"><b>{item.fullName}</b></Space>
                        </List.Item>
                    )}
                />
            </Modal>

            <div style={{ backgroundColor: '#f5f8fa', padding: 16, borderRadius: 8, marginBottom: 24 }}>

                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 12,
                        flexWrap: 'wrap',
                        marginBottom: 16,
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                        <h3 style={{ margin: 0 }}>Danh sách học sinh</h3>
                        <Input
                            allowClear
                            placeholder="Tìm theo họ tên hoặc CCCD"
                            value={studentKeyword}
                            onChange={(e) => setStudentKeyword(e.target.value)}
                            style={{ width: 320, maxWidth: '100%' }}
                        />
                        <Select
                            mode="multiple"
                            allowClear
                            placeholder="Lọc theo khoản thu đã đăng ký"
                            value={selectedIncomeFilter}
                            onChange={setSelectedIncomeFilter}
                            style={{ width: 350, maxWidth: '100%' }}
                            maxTagCount="responsive"
                            optionRender={(option) => (
                                <Space>
                                    <Checkbox checked={selectedIncomeFilter.includes(option.value as string)} style={{ pointerEvents: 'none' }} />
                                    {option.label}
                                </Space>
                            )}
                        >
                            <Select.Option value="UNREGISTERED" label="Chưa đăng ký">Chưa đăng ký</Select.Option>
                            {uniqueIncomes.map(income => (
                                <Select.Option key={income} value={income} label={income}>{income}</Select.Option>
                            ))}
                        </Select>
                        <Select
                            allowClear
                            placeholder="Lọc theo trạng thái invoice"
                            value={selectedInvoiceStatusFilter}
                            onChange={(value) => setSelectedInvoiceStatusFilter(value || null)}
                            style={{ width: 220, maxWidth: '100%' }}
                        >
                            <Select.Option value="NO_INCOME">Chưa có khoản thu</Select.Option>
                            <Select.Option value="NOT_INVOICED">Chưa tạo</Select.Option>
                            <Select.Option value="PARTIAL">Đã tạo một phần</Select.Option>
                            <Select.Option value="FULLY_INVOICED">Đã tạo đủ</Select.Option>
                        </Select>
                    </div>

                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        {isAccountant && (
                            <Button type="primary" onClick={handleOpenIncomeModal}>
                                Đăng ký khoản thu cho học sinh đã chọn
                            </Button>
                        )}
                        {isAdmin && (
                            <Button type="primary" icon={<PlusOutlined />} onClick={() => setShowModal(true)}>
                                Thêm học sinh
                            </Button>
                        )}
                    </div>
                </div>
                <div style={{ marginBottom: 12, fontStyle: 'italic', color: '#8c8c8c', fontSize: '13px' }}>
                    * Tích chọn những học sinh bạn muốn, hoặc tích ô trên cùng để chọn tất cả.
                </div>
                <Table
                    rowSelection={{
                        selectedRowKeys,
                        onChange: (newSelectedRowKeys) => setSelectedRowKeys(newSelectedRowKeys),
                    }}
                    columns={columns}
                    dataSource={filteredStudents}
                    rowKey={(record) => record.studentId}
                    pagination={false}
                    locale={{ emptyText: 'Không có học sinh nào' }}
                />

            </div>
            <Modal
                title={`Thêm nguồn thu cho ${selectedRowKeys.length} học sinh`}
                open={incomeModalVisible}
                onCancel={() => setIncomeModalVisible(false)}
                onOk={handleCreateIncome}
                okText="Thêm"
                cancelText="Hủy"
            >
                <Form layout="vertical" form={form} onValuesChange={(changedValues, allValues) => {
                    if (changedValues.incomeName || changedValues.monthYear || changedValues.schoolYear || changedValues.periodType) {
                        const name = allValues.incomeName || '';
                        let timeStr = '';
                        const currentPeriod = allValues.periodType || periodType;
                        if (currentPeriod === 'year') {
                            if (allValues.schoolYear) {
                                const y = allValues.schoolYear.year();
                                timeStr = ` Năm học ${y}-${y + 1}`;
                            }
                        } else {
                            if (allValues.monthYear) {
                                timeStr = ` ${allValues.monthYear.format('MM/YYYY')}`;
                            }
                        }
                        if (name || timeStr) {
                            form.setFieldsValue({ description: `${name}${timeStr}`.trim() });
                        }
                    }
                }}>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="type" label="Loại nhóm thu" rules={[{ required: true }]}>
                                <Select placeholder="Chọn loại" onChange={handleIncomeTypeChange}>
                                    <Select.Option value={1}>Nhóm ăn uống</Select.Option>
                                    <Select.Option value={2}>Nhóm học phí</Select.Option>
                                    <Select.Option value={3}>Nhóm học theo buổi (tiết)</Select.Option>
                                    <Select.Option value={4}>Nhóm chi phí khác</Select.Option>
                                    <Select.Option value={5}>Nhóm thu hộ</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="incomeName" label="Tên nguồn thu" rules={[{ required: true }]}>
                                <Select
                                    placeholder="Chọn tên"
                                    onChange={handleNameChange}
                                    disabled={!selectedIncomeType}
                                    notFoundContent={!selectedIncomeType ? "Vui lòng chọn Loại nhóm thu trước" : "Không có dữ liệu"}
                                >
                                    {incomeSources.map((source) => (
                                        <Select.Option key={source.id} value={source.name}>{source.name}</Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                            <Form.Item name="incomeSchoolId" hidden>
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>

                    {selectedIncomeType && (
                        <>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Form.Item name="unitPrice" label="Đơn giá" rules={[{ required: true }]}>
                                        <InputNumber
                                            style={{ width: '100%' }}
                                            min={0}
                                            addonAfter={selectedIncomeType === 1 ? "VND/ngày" : selectedIncomeType === 3 ? "VND/buổi" : undefined}
                                            formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                                            parser={(value) => value!.replace(/\./g, '') as any}
                                        />
                                    </Form.Item>
                                </Col>
                                {selectedIncomeType === 2 && (
                                    <Col span={12}>
                                        <Form.Item name="unitType" label="Đơn vị tính">
                                            <Select
                                                placeholder="Chọn đơn vị tính"
                                                style={{ width: '100%' }}
                                            >
                                                <Select.Option value="month">Theo tháng</Select.Option>
                                                <Select.Option value="semester">Theo kỳ (nửa năm học)</Select.Option>
                                                <Select.Option value="year">Theo năm học</Select.Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                )}
                                {[1, 2, 3].includes(selectedIncomeType) && (
                                    <Col span={12}>
                                        <Form.Item name="expectedUnits" label="Số buổi dự kiến" rules={[{ required: true }]}>
                                            <InputNumber style={{ width: '100%' }} min={1} />
                                        </Form.Item>
                                    </Col>
                                )}
                            </Row>

                            <Row gutter={16}>
                                <Col span={24}>
                                    {renderPeriodSelection()}
                                </Col>
                            </Row>

                            <Row gutter={16}>
                                <Col span={24}>
                                    <Form.Item name="description" label="Mô tả" rules={[{ required: true }]}>
                                        <Input.TextArea rows={2} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </>
                    )}
                </Form>
            </Modal>

            <Modal
                title="Tìm học sinh bằng CCCD"
                open={showModal}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                <Input.Search
                    placeholder="Nhập CCCD học sinh"
                    enterButton="Tìm kiếm"
                    loading={loadingSearch}
                    onSearch={handleSearchByCMND}
                />
                <List
                    style={{ marginTop: 16 }}
                    dataSource={searchResults}
                    bordered
                    renderItem={(item) => (
                        <List.Item actions={[<Button type="link" onClick={() => handleAddStudent(item.studentId)}>Thêm</Button>]}>
                            <Space direction="vertical">
                                <div><b>{item.name}</b> ({item.studentCode})</div>
                                <div>{item.dob} - CCCD: {item.cmnd}</div>
                            </Space>
                        </List.Item>
                    )}
                />
            </Modal>

            <Modal
                title="Chi tiết nguồn thu học sinh"
                open={isDetailModalOpen}
                onCancel={() => {
                    setIsDetailModalOpen(false);
                    setSelectedStudentForDetail(undefined);
                    if (classYearId) {
                        fetchStudentsInClass(classYearId);
                    }
                }}
                footer={null}
                width={1250}
                destroyOnClose
            >
                <div style={{ maxHeight: '75vh', overflowY: 'auto', paddingRight: '8px' }}>
                    {selectedStudentForDetail && classYearId && (
                        <>
                            <div style={{ marginBottom: 16, fontSize: 15 }}>
                                <strong>Họ tên:</strong> {selectedStudentForDetail.name} <span style={{ margin: '0 8px', color: '#ccc' }}>|</span>
                                <strong>Lớp:</strong> {classInfo?.className} <span style={{ margin: '0 8px', color: '#ccc' }}>|</span>
                                <strong>Ngày sinh:</strong> {selectedStudentForDetail.dob} <span style={{ margin: '0 8px', color: '#ccc' }}>|</span>
                                <strong>CMND/CCCD:</strong> {selectedStudentForDetail.cmnd}
                            </div>
                            <StudentFullInfo
                                studentId={selectedStudentForDetail.studentId}
                                classYearId={classYearId}
                            />
                        </>
                    )}
                </div>
            </Modal>
        </div>
    );
};
